import React from "react";
import "./subButton2.css";

export default function SubButton2() {
  return (
    <button
      onClick={() => window.open("https://wepublic.com/c/matzip?tab=feed")}
      className="button2"
    >
      DAO돌아가기
    </button>
  );
}
